import React from 'react';
import { map } from 'lodash-es';
import './Category.scss';
import Lottie from 'lottie-react';
import { useGetCategoryByIdQuery } from '../../store/menu/menuApi';
import loader from '../../assets/lotties/loader.json';
import { IGetMenuItemResponse } from '../../proto/menu/item/menuItem';
import { MenuItem } from '../MenuItem/MenuItem';
import { UpsertMenuItem } from './UpsertMenuItem/UpsertMenuItem';
import { useModal } from '../../providers/ModalProvider/ModalProvider';
import { EditItem } from '../../modules/EditItem/EditItem';
import { UpsertCategory } from './UpsertCategory/UpsertCategory';

interface ICategoryProps {
	menuId: string;
	categoryId: string;
}

export const Category = ({ menuId, categoryId }: ICategoryProps): JSX.Element => {
	const { data: category, isLoading } = useGetCategoryByIdQuery({ menuId, categoryId }, { skip: !categoryId });
	const { openModal } = useModal();

	const handleItemClicked = (menuItemId: string): void => {
		const closeModal = openModal(
			<UpsertMenuItem
				onSubmit={(): void => {
					closeModal();
				}}
				onCancel={(): void => {
					closeModal();
				}}
				menuId={menuId}
				categoryId={categoryId}
				menuItemId={menuItemId}
			/>
		);
	};

	const handelEditCategoryClick = (): void => {
		const closeModal = openModal(
			<UpsertCategory
				onSubmit={(): void => {
					closeModal();
				}}
				onCancel={(): void => {
					closeModal();
				}}
				menuId={menuId}
				categoryId={categoryId}
			/>
		);
	};

	const handleAddItemClicked = (): void => {
		const closeModal = openModal(
			<UpsertMenuItem
				onSubmit={(): void => {
					closeModal();
				}}
				onCancel={(): void => {
					closeModal();
				}}
				menuId={menuId}
				categoryId={categoryId}
			/>
		);
	};

	return (
		<>
			{isLoading ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<div className="categoryContainer">
					<div className="manageCategoryButtons">
						<div className="manageCategoryButton" onClick={handleAddItemClicked}>
							הוסף מוצר +
						</div>
						<div className="manageCategoryButton" onClick={handelEditCategoryClick}>
							ערוך פרטי קטגוריה
							<EditItem />
						</div>
					</div>
					<div className="menuItemsList">
						{map(category?.items, (item: IGetMenuItemResponse) => (
							<MenuItem key={item.id} item={item} onClick={(): void => handleItemClicked(item.id)} />
						))}
					</div>
				</div>
			)}
		</>
	);
};
